import React from 'react';
import Header from '../directives/header';
import { Container, Row, Col, Button, Card, Form } from 'react-bootstrap';
import Footer from '../directives/footer';
import '../css/launchprocess.css';

const Termsofuse = () => {
  return (
    <>
      <Header />
      <div className="subheader">
        <Container>
          <Row>
            <Col lg={12}>
              <h2>Terms of Use</h2>
            </Col>
          </Row>
        </Container>
      </div>
      <section className="launchprocess pt-5">
        <Container className="position-relative">
          <Row className="align-items-center">
            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">1. Introduction</h4>
              </div>
              <p>
                Welcome to{' '}
                <b className="text-white fw-normal">Unitronix Corp.</b>{' '}
                ("Unitronix," "we," "our," or "us"). These{' '}
                <b className="text-white fw-normal">Terms of Use ("Terms")</b>{' '}
                govern your access and use of our website, platform, and
                services. By accessing our website{' '}
                <a
                  href="https://www.unitronix.ai"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.unitronix.ai
                </a>
                (the “Website”), you agree to comply with these Terms. If you do
                not agree, please{' '}
                <b className="text-white fw-normal">do not use the Website.</b>
              </p>
            </Col>
            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">
                  2. Eligibility & Use
                </h4>
              </div>
              <p>By using this Website, you confirm that:</p>
              <div>
                <ul>
                  <li className="mb-2">
                    You are{' '}
                    <b className="text-white fw-normal">
                      at least 18 years old{' '}
                    </b>
                    or of legal age in your jurisdiction.
                  </li>
                  <li className="mb-2">
                    You will{' '}
                    <b className="text-white fw-normal">
                      not use our services for any unlawful activities{' '}
                    </b>
                    , including fraud, money laundering, or securities
                    violations.
                  </li>
                  <li className="mb-2">
                    You understand that{' '}
                    <b className="text-white fw-normal">
                      investing in stocks, cryptocurrencies and tokenized assets
                      carries risks,{' '}
                    </b>
                    including volatility and potential loss of funds.
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">
                  3. Intellectual Property Rightse
                </h4>
              </div>
              <div>
                <ul>
                  <li className="mb-2">
                    All content on the Website, including logos, text, graphics,
                    software, and trademarks, is{' '}
                    <b className="text-white fw-normal">
                      owned or licensed by Unitronix and protected by
                      intellectual property laws.{' '}
                    </b>
                  </li>
                  <li className="mb-2">
                    You may{' '}
                    <b className="text-white fw-normal">
                      not copy, modify, distribute, or use any content{' '}
                    </b>
                    , without prior written permission.
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">
                  4. Prohibited Activities
                </h4>
              </div>
              <p>You agree not to:</p>
              <div>
                <ul>
                  <li className="mb-2">
                    Use the Website for{' '}
                    <b className="text-white fw-normal">
                      any illegal, fraudulent, or unauthorized activities.{' '}
                    </b>
                  </li>
                  <li className="mb-2">
                    Attempt to{' '}
                    <b className="text-white fw-normal">
                      hack, interfere, or disrupt the Website’s functionality.{' '}
                    </b>
                  </li>
                  <li className="mb-2">
                    Engage in{' '}
                    <b className="text-white fw-normal">
                      misrepresentation or impersonation{' '}
                    </b>
                    of Unitronix or its affiliates.
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">
                  5. Investment & Financial Risk Disclaimer
                </h4>
              </div>
              <p>You agree not to:</p>
              <div>
                <ul>
                  <li className="mb-2">
                    Unitronix{' '}
                    <b className="text-white fw-normal">
                      does not provide financial, investment, or legal advice.
                    </b>
                  </li>
                  <li className="mb-2">
                    Cryptocurrency investments are{' '}
                    <b className="text-white fw-normal">
                      high-risk and subject to significant price volatility.
                    </b>
                  </li>
                  <li className="mb-2">
                    You should conduct your own research or consult a financial
                    professional before making any investment decisions.
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">
                  6. Limitation of Liability
                </h4>
              </div>
              <p>You agree not to:</p>
              <div>
                <ul>
                  <li className="mb-2">
                    Unitronix is{' '}
                    <b className="text-white fw-normal">
                      not responsible for losses incurred from investments,
                      service disruptions, or third-party services{' '}
                    </b>
                    linked to our platform.
                  </li>
                  <li className="mb-2">
                    We <b className="text-white fw-normal">do not guarantee </b>
                    that our Website will be uninterrupted, error-free, or
                    always secure.
                  </li>
                  <li className="mb-2">
                    You should conduct your own research or consult a financial
                    professional before making any investment decisions.
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">
                  7. Changes to These Terms
                </h4>
              </div>
              <p>You agree not to:</p>
              <div>
                <ul>
                  <li className="mb-2">
                    We{' '}
                    <b className="text-white fw-normal">
                      may update these Terms at any time,{' '}
                    </b>
                    and the latest version will be posted on our Website.
                  </li>

                  <li className="mb-2">
                    Your continued use of the Website after updates constitutes
                    acceptance of the new Terms.
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">
                  8. Governing Law & Dispute Resolution
                </h4>
              </div>
              <div>
                <ul>
                  <li className="mb-2">
                    These Terms are{' '}
                    <b className="text-white fw-normal">
                      governed by the laws of the United States.{' '}
                    </b>
                  </li>

                  <li className="mb-2">
                    Any disputes must be resolved{' '}
                    <b className="text-white fw-normal">through arbitration </b>
                    or legal proceedings in our jurisdiction.
                  </li>
                </ul>
              </div>
            </Col>
            <div>
              <p>
                For inquiries, contact us at{' '}
                <a href="mailto:info@unitronix.ai">info@unitronix.ai</a>
              </p>
            </div>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};
export default Termsofuse;
